import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { createOtTableColumnInstance } from '@1trading/design-system';
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { PricetickModel } from '@exchange/libs/price-ticks/service/src';

import PriceTicksHistoryItem from './PriceTicksHistoryItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceTicksHistoryList',
  props: {
  /** Price ticks to show */
  priceTicks: { type: Array as PropType<Array<PricetickModel>>, required: true },
  /** Market id */
  marketId: { type: String, required: true },
  /** Market amount precision */
  amountPrecision: { type: Number, required: true },
  /** Market market precision */
  marketPrecision: { type: Number, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const header = computed(() => [
  createOtTableColumnInstance({
    title: '',
    columnClass: 'text-align-right  price-ticks-history-list__column-cell',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.amount'),
    columnClass: 'text-align-right price-ticks-history-list__column-cell price-ticks-history-list__column-cell--value',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.price'),
    columnClass: 'text-align-right  price-ticks-history-list__column-cell price-ticks-history-list__column-cell--value',
  }),
  createOtTableColumnInstance({
    title: t('modules.marketHistory.header.time'),
    columnClass: 'text-align-right  price-ticks-history-list__column-cell price-ticks-history-list__column-cell--time',
  }),
]);

const showArrow = (index: number) => {
  if (!props.priceTicks[index + 1]) {
    return false;
  }

  const thisTick = props.priceTicks[index];
  const nextTick = props.priceTicks[index + 1];

  return thisTick?.price !== nextTick?.price || thisTick?.takerSide !== nextTick?.takerSide;
};

return (_ctx: any,_cache: any) => {
  const _component_ot_table = _resolveComponent("ot-table")!

  return (_openBlock(), _createBlock(_component_ot_table, {
    key: __props.marketId,
    class: _normalizeClass(['price-ticks-history-list']),
    header: header.value,
    rows: []
  }, {
    default: _withCtx(({ rowClass }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.priceTicks, (priceTick, index) => {
        return (_openBlock(), _createBlock(PriceTicksHistoryItem, {
          key: priceTick.internalId,
          class: _normalizeClass(rowClass),
          "amount-precision": __props.amountPrecision,
          "market-precision": __props.marketPrecision,
          "price-tick": priceTick,
          "show-arrow": showArrow(index)
        }, null, 8, ["class", "amount-precision", "market-precision", "price-tick", "show-arrow"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["header"]))
}
}

})